import { render, staticRenderFns } from "./AddressPane.vue?vue&type=template&id=5bccf92a&scoped=true"
import script from "./AddressPane.vue?vue&type=script&lang=ts"
export * from "./AddressPane.vue?vue&type=script&lang=ts"
import style0 from "./AddressPane.vue?vue&type=style&index=0&id=5bccf92a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bccf92a",
  null
  
)

export default component.exports